import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function UpdateTemplateFileForm() {
  const { id } = useParams();
  const { authFetch } = useAuth();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setLoading(true);
    setError(null);
    try {
      // 1. Upload file to /file-upload
      const uploadData = new FormData();
      uploadData.append('file', file);
      const uploadResp = await authFetch('/api/v1/file-upload', {
        method: 'POST',
        body: uploadData
      });
      if (!uploadResp.ok) {
        setError('Ошибка при загрузке файла (этап 1)');
        setLoading(false);
        return;
      }
      const uploadJson = await uploadResp.json();
      const file_id = uploadJson.file_id;
      if (!file_id) {
        setError('Не удалось получить file_id после загрузки файла');
        setLoading(false);
        return;
      }
      // 2. Send file_id to /api/v1/template-docs/:id/file
      const response = await authFetch(`/api/v1/template-docs/${id}/file`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ file_id: file_id.id })
      });
      if (response.ok) {
        setSuccess(true);
        setTimeout(() => navigate(`/template-docs/${id}`), 1200);
      } else {
        setError('Ошибка при обновлении шаблона (этап 2)');
      }
    } catch (err) {
      setError('Ошибка: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">Обновить файл шаблона</h2>
      <form onSubmit={handleSubmit} className="card p-4 shadow-sm" style={{maxWidth: 500}}>
        <div className="mb-3">
          <label htmlFor="templateFile" className="form-label">Выберите новый файл шаблона</label>
          <input
            type="file"
            className="form-control"
            id="templateFile"
            accept=".doc,.docx,.pdf,.rtf,.odt"
            onChange={handleFileChange}
            required
          />
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">Файл успешно обновлён!</div>}
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Загрузка...' : 'Загрузить'}
        </button>
        <button type="button" className="btn btn-outline-secondary ms-2" onClick={() => navigate(-1)} disabled={loading}>
          Отмена
        </button>
      </form>
    </div>
  );
}

export default UpdateTemplateFileForm; 